var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-steps',{attrs:{"active":_vm.activeNumber,"simple":""}},_vm._l((_vm.titleArray),function(item,index){return _c('el-step',{key:item,class:_vm.activeNumber === index + 1 ? 'active' : '',attrs:{"title":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }